import styled from "styled-components";

export const FormDivider = styled.div`
    height: 1px;
    width: 100%;
    border-bottom: 1px solid #a3a3a3;
    margin-top: 3em;
    margin-bottom: 3em;

    &:after {
        content: "${props => props.onDividerText}";
        font-size: 10pt;
        color: #a3a3a3;
        position: relative;
        background-color: #fff;
        top: -1em;
        left: 40%;
        padding: 1em;
    }
`;
